const fontArray = ['Unica77 LL', 'sans-serif'].join(',')
const fontArrayMono = ['Unica77 Mono LL', 'sans-serif'].join(',')

export const typographyOptions = {
  fontFamily: fontArray,
  'body-1': {
    fontFamily: 'Unica77 LL',
    fontSize: '12px',
    fontWeight: 400,
    letterSpacing: '0.12em',
    lineHeight: '16.2px',
    textTransform: 'none',
    textDecoration: 'none'
  } as const,
  'body-2': {
    fontFamily: fontArray,
    fontSize: '12px',
    fontWeight: 500,
    letterSpacing: '0.12em',
    lineHeight: '16.2px',
    textTransform: 'none',
    textDecoration: 'none'
  } as const,
  'body-3': {
    fontFamily: fontArrayMono,
    fontSize: '12px',
    fontWeight: 400,
    letterSpacing: '0em',
    lineHeight: '16.2px',
    textTransform: 'none',
    textDecoration: 'none'
  } as const,
  'body-4': {
    fontFamily: fontArray,
    fontSize: '14px',
    fontWeight: 400,
    letterSpacing: '0em',
    lineHeight: '18.9px',
    textTransform: 'none',
    textDecoration: 'none'
  } as const,
  'body-5': {
    fontFamily: fontArray,
    fontSize: '14px',
    fontWeight: 500,
    letterSpacing: '0em',
    lineHeight: '18.9px',
    textTransform: 'none',
    textDecoration: 'none'
  } as const,
  'body-6': {
    fontFamily: fontArrayMono,
    fontSize: '14px',
    fontWeight: 400,
    letterSpacing: '0em',
    lineHeight: '18.9px',
    textTransform: 'none',
    textDecoration: 'none'
  } as const,
  'body-7': {
    fontFamily: fontArray,
    fontSize: '16px',
    fontWeight: 400,
    letterSpacing: '0em',
    lineHeight: '20.8px',
    textTransform: 'none',
    textDecoration: 'none'
  } as const,
  'body-8': {
    fontFamily: fontArray,
    fontSize: '16px',
    fontWeight: 500,
    letterSpacing: '0em',
    lineHeight: '20.8px',
    textTransform: 'none',
    textDecoration: 'none'
  } as const,
  'body-9': {
    fontFamily: fontArrayMono,
    fontSize: '16px',
    fontWeight: 400,
    letterSpacing: '0em',
    lineHeight: '20.8px',
    textTransform: 'none',
    textDecoration: 'none'
  } as const,
  'body-10': {
    fontFamily: fontArray,
    fontSize: '18px',
    fontWeight: 400,
    letterSpacing: '0em',
    lineHeight: '23.4px',
    textTransform: 'none',
    textDecoration: 'none'
  } as const,
  'body-11': {
    fontFamily: fontArray,
    fontSize: '18px',
    fontWeight: 500,
    letterSpacing: '0em',
    lineHeight: '23.4px',
    textTransform: 'none',
    textDecoration: 'none'
  } as const,
  'body-12': {
    fontFamily: fontArrayMono,
    fontSize: '18px',
    fontWeight: 400,
    letterSpacing: '0em',
    lineHeight: '23.4px',
    textTransform: 'none',
    textDecoration: 'none'
  } as const,
  'heading-1': {
    fontFamily: fontArray,
    fontSize: '20px',
    fontWeight: 400,
    letterSpacing: '0em',
    lineHeight: '26px',
    textTransform: 'none',
    textDecoration: 'none'
  } as const,
  'heading-2': {
    fontFamily: fontArray,
    fontSize: '20px',
    fontWeight: 500,
    letterSpacing: '0em',
    lineHeight: '26px',
    textTransform: 'none',
    textDecoration: 'none'
  } as const,
  'heading-3': {
    fontFamily: fontArray,
    fontSize: '24px',
    fontWeight: 400,
    letterSpacing: '0em',
    lineHeight: '28.8px',
    textTransform: 'none',
    textDecoration: 'none'
  } as const,
  'heading-4': {
    fontFamily: fontArray,
    fontSize: '24px',
    fontWeight: 500,
    letterSpacing: '0em',
    lineHeight: '28.8px',
    textTransform: 'none',
    textDecoration: 'none'
  } as const,
  'heading-5': {
    fontFamily: fontArray,
    fontSize: '30px',
    fontWeight: 400,
    letterSpacing: '0em',
    lineHeight: '33px',
    textTransform: 'none',
    textDecoration: 'none'
  } as const,
  'heading-6': {
    fontFamily: fontArray,
    fontSize: '30px',
    fontWeight: 500,
    letterSpacing: '0em',
    lineHeight: '33px',
    textTransform: 'none',
    textDecoration: 'none'
  } as const,
  'heading-7': {
    fontFamily: fontArray,
    fontSize: '36px',
    fontWeight: 400,
    letterSpacing: '-0.02em',
    lineHeight: '36px',
    textTransform: 'none',
    textDecoration: 'none'
  } as const,
  'heading-8': {
    fontFamily: fontArray,
    fontSize: '36px',
    fontWeight: 500,
    letterSpacing: '-0.02em',
    lineHeight: '36px',
    textTransform: 'none',
    textDecoration: 'none'
  } as const,
  'ui-1': {
    fontFamily: fontArray,
    fontSize: '12px',
    fontWeight: 700,
    letterSpacing: '0em',
    lineHeight: '18.9px',
    textTransform: 'uppercase',
    textDecoration: 'none'
  } as const,
  'ui-2': {
    fontFamily: fontArray,
    fontSize: '14px',
    fontWeight: 500,
    letterSpacing: '0em',
    lineHeight: '18.9px',
    textTransform: 'none',
    textDecoration: 'none'
  } as const,
  'ui-3': {
    fontFamily: fontArray,
    fontSize: '18px',
    fontWeight: 500,
    letterSpacing: '0em',
    lineHeight: '18.9px',
    textTransform: 'none',
    textDecoration: 'none'
  } as const
}
